import {
    Box,
    chakra,
    Flex,
    Image,
    Divider,
    AbsoluteCenter,
    Link,
    Button,
    HStack,
    SimpleGrid,
} from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';


const EventIntro_9 = ({ activity }) => {
    return (
        <Flex
            textAlign={'center'}
            pt={10}
            justifyContent={'center'}
            direction={'column'}
            width={'full'}>
            <Box width="100%" margin={'auto'}>
                <chakra.h1
                    py={5}
                    fontSize={40}
                    fontWeight={'bold'}
                    color={'gray.700'}
                    >
                    {activity.title}
                </chakra.h1>
            </Box>
            <Box
                boxShadow={'lg'}
                alignItem={'center'}
                width={'100%'}
                rounded={'xl'}
                p={10}
                position={'relative'}
                bg={'white'}
                _after={{
                    content: '""',
                    position: 'absolute',
                    height: '50px',
                    width: '50px',
                    left: '25px',
                    top: '-20px',
                    backgroundSize: 'cover',
                    backgroundImage: "url('/quotation_marks.png')",
                }}>
                <Box position='relative' padding='10'>
                    <Divider  borderColor={'gray.400'}/>
                    <AbsoluteCenter bg='white' px='4'>
                        <chakra.h2
                            py={5}
                            fontSize={35}
                            fontWeight={'bold'}
                            color={'gray.700'}
                            >
                            活動簡介
                        </chakra.h2>
                    </AbsoluteCenter>
                </Box>
                <Box
                    textAlign={'left'}>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.intro}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'18px'}
                        color={'gray.600'}
                        pb={2}
                    >
                        時　　間｜{activity.date} {activity.time}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'18px'}
                        color={'gray.600'}
                        pb={4}
                    >
                        地　　點｜{activity.place}
                    </chakra.p>
                </Box>
                <Flex>
                    <Image
                        src={`../activity/${activity.fileName}`}
                        alt="NONE"
                        mx="auto"
                    />
                </Flex>
                <Box position='relative' padding='10' mt='8'>
                    <Divider  borderColor={'gray.400'}/>
                    <AbsoluteCenter bg='white' px='4'>
                        <chakra.h2
                            py={5}
                            fontSize={35}
                            fontWeight={'bold'}
                            color={'gray.700'}
                            >
                            活動總覽
                        </chakra.h2>
                    </AbsoluteCenter>
                </Box>
                <Box textAlign={'left'}>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[0]}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[1]}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[2]}
                    </chakra.p>
                </Box>
                <Box textAlign={'left'} pt={2}>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'18px'}
                        color={'gray.600'}
                    >
                        {activity.paragraph[3]} <br/>
                        {activity.paragraph[4]}
                    </chakra.p>
                </Box>
                {activity.pics && activity.pics.length > 0 && (
                    <>
                        <Box position='relative' padding='10' mt='8' mb='2'>
                            <Divider  borderColor={'gray.400'}/>
                            <AbsoluteCenter bg='white' px='4'>
                                <chakra.h2
                                    py={5}
                                    fontSize={35}
                                    fontWeight={'bold'}
                                    color={'gray.700'}
                                    >
                                    活動花絮
                                </chakra.h2>
                            </AbsoluteCenter>
                        </Box>
                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                            {activity.pics.map((pic, i) => (
                                <Image
                                    key={i}
                                    src={`../activity/${pic}`}
                                    alt="NONE"
                                    objectFit="cover"
                                    width="100%"
                                    height={{ base: '220px', md: '300px' }}
                                    borderRadius="md"
                                />
                            ))}
                        </SimpleGrid>
                        {activity.link && activity.link[2] && (
                            <Box textAlign={'left'} pt={4}>
                                <Link color="#437070" href={activity.link[2]} isExternal fontWeight="medium">
                                    📷 詳細活動照片請見此連結
                                </Link>
                            </Box>
                        )}
                    </>
                )}
                {activity.link && activity.link.length > 0 && (
                    <HStack spacing={3} flexWrap="wrap" justify="flex-start" pt={6}>
                        {activity.link[0] && (
                            <Link href={activity.link[0]} isExternal _hover={{ textDecoration: 'none' }}>
                                <Button
                                    bg="#437070"
                                    color="white"
                                    rightIcon={<ExternalLinkIcon />}
                                    _hover={{ bg: '#70a9a9' }}
                                >
                                    活動官方網站
                                </Button>
                            </Link>
                        )}
                        {activity.link[1] && (
                            <Link href={activity.link[1]} isExternal _hover={{ textDecoration: 'none' }}>
                                <Button
                                    variant="outline"
                                    borderColor="#437070"
                                    color="#437070"
                                    rightIcon={<ExternalLinkIcon />}
                                    _hover={{ bg: '#eff5f5' }}
                                >
                                    AINTU 公告頁
                                </Button>
                            </Link>
                        )}
                        {activity.link[3] && (
                            <Link href={activity.link[3]} isExternal _hover={{ textDecoration: 'none' }}>
                                <Button
                                    variant="outline"
                                    borderColor="#437070"
                                    color="#437070"
                                    rightIcon={<ExternalLinkIcon />}
                                    _hover={{ bg: '#eff5f5' }}
                                >
                                    活動海報與簡報
                                </Button>
                            </Link>
                        )}
                    </HStack>
                )}
            </Box>
        </Flex>
    )
}
export default EventIntro_9;
